import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import {
  CardElements,
  CardsGridElements,
  Classes,
  Colors,
  GeneralCardSubElements,
} from "@/types";
import {
  canCardArrayVModel,
  getBreakpoint,
  getBreakpointClasses,
} from "@/utils";
import { IonGrid, IonRow, IonCol } from "@ionic/vue";
import {
  PropType,
  WatchStopHandle,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardsGrid',
  props: {
  cards_list: {
    type: Array<CardElements>,
    required: true,
  },
  columns: {
    type: Number,
    required: true,
  },
  colors: Object as PropType<Colors<GeneralCardSubElements>>,
  classes: Object as PropType<Classes<CardsGridElements>>,
},
  emits: ["execute_link", "signal_event", "update:cards_list"],
  setup(__props, { emit }) {

const props = __props;

const addListeners = () => {
  watch(
    () => props.cards_list,
    (value) => {
      cards_list_ref.value = value;
    }
  );
  watch(
    () => cards_list_ref.value,
    (value) => {
      emit("update:cards_list", value);
    }
  );
};
const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};




const breakpoint = ref(getBreakpoint(window.innerWidth));

const cards_list_ref = ref(props.cards_list);

let stopWatch: WatchStopHandle;

if (props.cards_list.length == 0) {
  stopWatch = watch(
    () => props.cards_list,
    (value) => {
      cards_list_ref.value = value;
      if (value.length > 0 && canCardArrayVModel(props.cards_list)) {
        addListeners();
        stopWatch();
      }
    }
  );
} else if (canCardArrayVModel(props.cards_list)) {
  addListeners();
}

if (
  props.classes?.grid != undefined ||
  props.classes?.row != undefined ||
  props.classes?.col != undefined
) {
  onMounted(() =>
    nextTick(() => {
      window.addEventListener("resize", updateBreakpoint);
    })
  );

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateBreakpoint);
  });
}

return (_ctx: any,_cache: any) => {
  const _component_card_item = _resolveComponent("card-item")!

  return (_openBlock(), _createBlock(_unref(IonGrid), {
    class: _normalizeClass(_unref(getBreakpointClasses)(__props.classes?.grid, breakpoint.value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), {
        class: _normalizeClass([_unref(getBreakpointClasses)(__props.classes?.row, breakpoint.value), "ion-align-items-center"])
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards_list_ref.value, (card, i) => {
            return (_openBlock(), _createBlock(_unref(IonCol), {
              key: card.id,
              size: '' + Math.trunc(12 / __props.columns),
              class: _normalizeClass(_unref(getBreakpointClasses)(__props.classes?.col, breakpoint.value))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_card_item, {
                  card: cards_list_ref.value[i],
                  detail: false,
                  colors: __props.colors,
                  classes: __props.classes,
                  onExecute_link: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('execute_link'))),
                  onSignal_event: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('signal_event')))
                }, null, 8, ["card", "colors", "classes"])
              ]),
              _: 2
            }, 1032, ["size", "class"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})